import { Anchor, Box, Footer, Text } from 'grommet';
import { Anchor as AnchorIcon, FacebookOption, Instagram } from 'grommet-icons';
import React from 'react';

const Social = () => (
  <Footer
    background="rgb(0,17,47)"
    pad="small"
    direction="row"
    wrap
    justify="between"
    align="center"
    gap="small"
  >
    <Box align="center" direction="row" gap="xsmall">
      <AnchorIcon color="white" size="medium" />
      <Text alignSelf="center" color="white" size="small">
        Tønsberg Seilforening
      </Text>
    </Box>
    <Box direction="row" gap="xxsmall" justify="center">
      <Anchor
        a11yTitle="Share feedback on Instagram"
        href="https://www.instagram.com/tonsbergseilforening/"
        target="_blank"
        icon={<Instagram color="white" />}
      />
      <Anchor
        a11yTitle="Chat with us on Facebook"
        href="https://www.facebook.com/tonsbergseilforening/"
        target="_blank"
        icon={<FacebookOption color="white" />}
      />
    </Box>
    <Text textAlign="center" size="xsmall" color="white">
      made with ❤️
    </Text>
  </Footer>
);

export default Social;
